import React, { useState } from 'react'
import AutoSuggestionsdataSearch from './movieSearchAutosuggestion'
import { useDebounce } from 'use-debounce'
import SearchBar from '../../SearchMovie/SearchBar'
import { MdEdit } from 'react-icons/md'
import { Link } from 'react-router-dom'

function SearchBarinput(props) {
  const {
    movieAndWebSeries,
    handleMovieAndWebSeries,
    statusType,
    // searchValue,
    setSearchListTrue,
    setfilterDisableWithoutSelect,
    setDisapperAllFilters,
    searchListTrue,
    setSearch,
    isLoading,
    updateSearchValue,
    sortBy,
    setsortBy,
    sortByorderFromLIst,
    searchQuery,
    setSearchQuery,
  } = props
  //
  const [sortByorder, setsortOrderBy] = useState('desc')

  // const [searchQuery, setSearchQuery] = useState('')
  // const [sortBy, setsortBy] = useState('popularity')
  //
  const [value] = useDebounce(searchQuery, 2000)
  updateSearchValue(value)
  const [AutoSuggetions, setAutoSuggetions] = useState([])
  const handleSearchInput = async e => {
    setSearchQuery(e.target.value)
    setfilterDisableWithoutSelect(!(e.target.value > 0))
    setDisapperAllFilters(!(e.target.value.length > 0))
    const searchLimit = 10
    if (e.target.value.length > 3) {
      setSearchListTrue(true)
      const input = {
        search: e.target.value,
        type: movieAndWebSeries === 'movies' ? 'movie' : movieAndWebSeries,
        limit: searchLimit,
        from: 0,
        status: statusType,
      }
      const autoSuggestions = await AutoSuggestionsdataSearch(input)
      setAutoSuggetions(autoSuggestions.movieHits ? autoSuggestions.movieHits : [])
    } else {
      // setDisapperAllFilters(true)
      setSearchListTrue(false)
    }
  }

  const sortOrderReset = () => {
    setsortOrderBy('desc')
  }

  const sortByReset = () => {
    setsortBy('releaseYear')
  }

  function selectSuggestionlist(e) {
    // console.log('hhhhhh')
    setSearchQuery(e.target.getAttribute('value'))
    setSearch(e.target.getAttribute('value'))
    setSearchListTrue(false)
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', width: '16rem' }}>
        <label style={{ margin: '5px' }}>Search</label>
        <input
          // disabled={statusType === 'draft'}
          name='search'
          value={searchQuery}
          type='text'
          placeholder='search movies'
          onChange={handleSearchInput}
        ></input>
        <div
          style={{ border: ' 1px solid gray', borderRadius: '0px 0px 6px 6px', cursor: 'pointer' }}
        >
          {' '}
          {searchListTrue
            ? AutoSuggetions.length === 0
              ? 'No Data Found'
              : AutoSuggetions.map((item, index) => (
                  <div
                    className='d-flex pt-1 pb-1 justify-content-between gap-3'
                    style={{ padding: '2px' }}
                    key={index}
                  >
                    <div className='d-flex gap-2'>
                      <label value={item.title_En} onClick={selectSuggestionlist} key={index}>
                        {item.title_En}
                      </label>
                      <span>
                        {`(${item.movieReleasedDate &&
                          item.movieReleasedDate.toString().substr(0, 4)})`}
                      </span>
                    </div>
                    <Link
                      data-toggle='tooltip'
                      title={'Edit Movie'}
                      to={`/editmovie?${item.PK}`}
                      target='_blank'
                      className='text-dark'
                    >
                      <span className='border border-1 rounded p-1'>
                        <MdEdit />
                      </span>
                    </Link>
                  </div>
                ))
            : null}
        </div>{' '}
      </div>
      <div className='mt-4'>
        <fieldset>
          <label>Content Type</label>
          <div className='d-flex gap-2'>
            <div>
              <label htmlFor='movie'>
                Movie
                <input
                  id='movie'
                  type='radio'
                  value='movies'
                  checked={movieAndWebSeries === 'movies'}
                  onChange={handleMovieAndWebSeries}
                />
              </label>
            </div>
            <div>
              <label htmlFor='webseries'>
                Web Series
                <input
                  id='webseries'
                  type='radio'
                  value='webseries'
                  checked={movieAndWebSeries === 'webseries'}
                  onChange={handleMovieAndWebSeries}
                />
              </label>
            </div>
          </div>
        </fieldset>
      </div>

      {isLoading ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : (
        ''
      )}
      <SearchBar
        sortByorder={sortByorder}
        setsortOrderBy={setsortOrderBy}
        sortOrderReset={sortOrderReset}
        sortByReset={sortByReset}
        setSearchQuery={setSearchQuery}
        setSearch={setSearch}
        setMovieAndWebSeries={props.setMovieAndWebSeries}
        setLoaderServiceName={props.setLoaderServiceName}
        movieAndWebSeries={movieAndWebSeries}
        disapperAllFilters={props.disapperAllFilters}
        setTotalRenderedCount={props.setTotalRenderedCount}
        setSearchListTrue={setSearchListTrue}
        setIsLoading={props.setIsLoading}
        filterDisableWithoutSelect={props.filterDisableWithoutSelect}
        setDisapperAllFilters={setDisapperAllFilters}
        setfilterDisableWithoutSelect={setfilterDisableWithoutSelect}
        handleStatusType={props.handleStatusType}
        setsortByorderFromLIst={props.setsortByorderFromLIst}
        sortBy={sortBy}
        setsortBy={setsortBy}
        statusType={statusType}
        handlePublishedStatus={props.handlePublishedStatus}
        setcheckEmptyArray={props.setcheckEmptyArray}
        setmovieFilterByFromSearch={props.setmovieFilterByFromSearch}
        movieFilterBy={props.movieFilterBy}
        setCheckBoxArr={props.setCheckBoxArr}
        setLodeMoreDisble={props.setLodeMoreDisble}
        searchValue={props.searchValue}
        sortByorderFromLIst={sortByorderFromLIst}
        // setfilterMoviesdataTrue={setfilterMoviesdataTrue}
        setFromvalue={props.setFromvalue}
        setListMoviesDataItems={props.setListMoviesDataItems}
        // setGetNextToken={props.setGetNextToken}
        setHeaders={props.setHeaders}
        // setlistMoviestrue={setlistMoviestrue}
      />
    </div>
  )
}

export default SearchBarinput
